export const CANCEL_PERSON_HOLIDAY_ENTITLEMENT_EDIT_STATE = "cancelPersonHolidayEntitlementEditState";
export const DELETE_HOLIDAY_ENTITLEMENT = "deleteHolidayEntitlement";
export const DELETE_PERSON_HOLIDAY_ENTITLEMENT = "deleteHolidayEntitlement";
export const FETCH_PERSON_HOLIDAY_ENTITLEMENT_LIST = "r";
export const SAVE_EDITED_PERSON_HOLIDAY_ENTITLEMENT = "saveEditedHoliday";
export const SAVE_HOLIDAY_ENTITLEMENT = "saveHolidayEntitlement";
export const SAVE_NEW_PERSON_HOLIDAY_ENTITLEMENT = "rz";
export const SAVE_PERSON_HOLIDAY_ENTITLEMENT = "updatePersonHolidayEntitlement";
export const UPDATE_HOLIDAY_ENTITLEMENT = "updateHolidayEntitlement";
